import { onDomReady } from './utils/dom.js';
import { initTOCToggleButton } from './modules/toc.js';
import { initUserCreditsDetails } from './modules/user-credits.js';
import { initBannerCountdowns } from './modules/banner-countdown.js';
import { initFooterColumnLinks } from './modules/footer-columns.js';
import { subscribeFormHandler } from './modules/header-form.js';

onDomReady(() => {
	initUserCreditsDetails();
	initBannerCountdowns();
	initFooterColumnLinks();
	initTOCToggleButton();
	subscribeFormHandler();
});

